import { DateField, FunctionField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import ActionButton from '@/components/buttons/ActionButton';
import { MainDatagridStyled } from '@/styles/overrides';
import { MonitoringCriminalAlert } from '@/types/turn-api';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import CopyJSONToClipboard from './CopyJSONToClipboard';
import { path } from './constants';
import { ActionsContainer } from './styled';
import useController from './useController';

const CmActionsTab = (props: Partial<TabProps>) => {
  const { actionButtonCommonProps, runMatchAction, runNoMatchAction, stopRechecksAction, toggleNeedsCmAction } =
    useController();

  return (
    <Tab label="cm actions" {...props}>
      <ActionsContainer>
        <ActionButton label="Match" onClick={() => runMatchAction()} {...actionButtonCommonProps} />
        <ActionButton label="No Match" onClick={() => runNoMatchAction()} {...actionButtonCommonProps} />
        <ActionButton label="Stop Rechecks" onClick={() => stopRechecksAction()} {...actionButtonCommonProps} />
      </ActionsContainer>

      <ReferenceManyField reference={TurnReferencesEnum.CmCriminal} target={TurnTargetsEnum.GetAlerts} label="">
        <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
          <FunctionField
            render={(record: MonitoringCriminalAlert.Base) => {
              toggleNeedsCmAction(record?.needs_cm_action);
              return null;
            }}
          />
          <TextField source={path('status')} />
          <TextField source={path('type')} />
          <TextField source={path('county')} />
          <TextField source={path('state')} />
          <TextField source={path('zipcode')} />
          <DateField label="Created At" source={path('create_at')} showTime />
          <DateField label="Updated At" source={path('updated_at')} showTime />
          <CopyJSONToClipboard />
        </MainDatagridStyled>
      </ReferenceManyField>
    </Tab>
  );
};

export default CmActionsTab;
